export enum TextType {
  Text2d = 'text_2d',
  Text3d = 'text_3d',
  Text3dTexture = 'text_3d_texture'
}
